// Third Party Plugins
import React from 'react';
// Images
import AEFLogoLight from '@svg/aef-lightmode-logo.svg';
import AEFTextLogoLight from '@svg/aef-text-lightmode-logo.svg';
// Styles
import {
  StyledLogoTextOnly,
  StyledLogoMedium,
  StyledLogoLarge,
} from './styles';

function Logo({ mode = 'light', size = 'medium' }) {
  // Render the appropriate logo based on the mode and size
  if (mode === 'light') {
    switch (size) {
      case 'large':
        return (
          <StyledLogoLarge>
            <AEFLogoLight aria-label="Animation Educators Forum logo" />
          </StyledLogoLarge>
        );
      case 'textOnly':
        return (
          <StyledLogoTextOnly>
            <AEFTextLogoLight aria-label="Asifa Hollywood's Animation Educators Forum Wordmark" />
          </StyledLogoTextOnly>
        );
      case 'medium':
      default:
        return (
          <StyledLogoMedium>
            <AEFLogoLight aria-label="Animation Educators Forum logo" />
          </StyledLogoMedium>
        );
    }
  } else {
    switch (size) {
      case 'large':
        return (
          <StyledLogoLarge>
            <AEFLogoLight aria-label="Animation Educators Forum logo" />
          </StyledLogoLarge>
        );
      case 'textOnly':
        return (
          <StyledLogoTextOnly>
            <AEFTextLogoLight aria-label="Asifa Hollywood's Animation Educators Forum Wordmark" />
          </StyledLogoTextOnly>
        );
      case 'medium':
      default:
        return (
          <StyledLogoMedium>
            <AEFLogoLight aria-label="Animation Educators Forum logo" />
          </StyledLogoMedium>
        );
    }
  }
}

export default Logo;
